<template>
  <v-container class="my-12">
    <!-- Sección principal -->
    <v-row align="start" justify="center">
      <!-- Imagen -->
      <v-col cols="12" md="5">
        <v-img
          :src="require('@/assets/equipo.jpg')"
          alt="Equipo multidisciplinario de Consultora Innova A&G"
          class="elevation-5"
          height="350px"
          contain
        ></v-img>
      </v-col>

      <!-- Texto -->
      <v-col cols="12" md="7">
        <h2 class="display-1 font-weight-bold mb-4 purple--text text--darken-2">
          Sobre Nosotros
        </h2>

        <p class="subtitle-1 mb-4">
          En <strong>Consultora Innova A&G</strong> somos su aliado estratégico integral
          en transformación digital y talento humano. Nos especializamos en conectar la
          innovación tecnológica con las necesidades reales del mercado, ofreciendo
          soluciones a la medida para potenciar el crecimiento de profesionales y
          organizaciones.
        </p>

        <p class="subtitle-1 mb-4">
          <strong>Nuestros Servicios:</strong><br />
          1. <strong>Formación Tecnológica de Alto Nivel:</strong> Capacitación práctica y
          actualizada en lenguajes y entornos clave como
          <strong>Java, .NET, Python</strong> y tecnologías emergentes, diseñada para
          cerrar la brecha entre el conocimiento y la demanda industrial.<br /><br />
          2.
          <strong>Outsourcing de Talento Especializado (Staff Augmentation):</strong>
          Proporcionamos profesionales calificados en TI y otros sectores, integrando
          equipos ágiles y competentes que se adaptan a sus proyectos y objetivos.<br /><br />
          3. <strong>Desarrollo de Software a la Medida:</strong> Creamos soluciones
          tecnológicas robustas, escalables e innovadoras, desde aplicaciones web y
          móviles hasta sistemas empresariales complejos.
        </p>

        <p class="subtitle-1 mb-6">
          4. <strong>Soporte Técnico Especializado:</strong> Ofrecemos mantenimiento,
          monitoreo y asistencia técnica proactiva para garantizar la continuidad
          operativa y el óptimo desempeño de sus sistemas y plataformas.<br /><br />
          5. <strong>Soluciones de Contact Center & BPO:</strong> Gestionamos y
          optimizamos sus canales de comunicación con el cliente (Call Center
          omnichannel), mejorando la experiencia de usuario y la operatividad.<br /><br />
          6. <strong>Consultoría en Gestión de Recursos Humanos:</strong> Acompañamos en
          la atracción, selección, desarrollo y retención del mejor talento, alineando la
          estrategia de personas con la visión de negocio.<br /><br />
          <strong>Nuestra Misión:</strong> Brindar herramientas, talento y soluciones
          tecnológicas de vanguardia que permitan a nuestros clientes enfrentar con éxito
          los retos del entorno digital, acelerando su evolución y garantizando resultados
          tangibles.
        </p>

        <v-btn color="deep-purple" large rounded elevation="2" class="mr-4">
          Conoce nuestros servicios
        </v-btn>
      </v-col>
    </v-row>

    <!-- Sección Únete a nuestra familia -->
    <v-row class="mt-12" align="center" justify="center">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold mb-4 orange--text text--darken-2">
          ¡Únete a nuestra familia!
        </h2>
        <p class="subtitle-1 mb-6">
          Si eres un <strong>profesional con experiencia</strong> en áreas como desarrollo
          de software, ingeniería de datos, análisis de datos, cloud computing,
          inteligencia artificial, ciberseguridad, soporte técnico o automatización de
          procesos, te invitamos a formar parte de nuestro equipo. Comparte tu
          conocimiento, impulsa el crecimiento de nuevos talentos y contribuye a
          <strong>expandir nuestra propuesta de servicios a nivel regional</strong>.
        </p>
        <v-btn color="orange darken-2" large rounded elevation="2">
          Postula con nosotros
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NosotrosPage",
};
</script>

<style scoped>
h2 {
  letter-spacing: -1px;
}
.subtitle-1 {
  line-height: 1.7;
}
</style>
